// extracted by mini-css-extract-plugin
export default {"imageTag":"Header_imageTag__IM96f","imageTagHome":"Header_imageTagHome__M7wva","imgClassHome":"Header_imgClassHome__CjNcp"};